import { render, staticRenderFns } from "./DataEmpty.vue?vue&type=template&id=61929404&scoped=true"
import script from "./DataEmpty.vue?vue&type=script&lang=js"
export * from "./DataEmpty.vue?vue&type=script&lang=js"
import style0 from "./DataEmpty.vue?vue&type=style&index=0&id=61929404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61929404",
  null
  
)

export default component.exports